import axios from 'axios';
/**
 * La mayor diferencia con el functions de la api de Paradigma es la forma en la que se genera la url,
 * ya que Georef no utiliza / (forwardslash) al final de la url.
 */

function generateUrl(url, parameters) {
    let newurl = url;

    if (parameters) {
        newurl += "?";
        if (parameters.hasOwnProperty("filters")) newurl += parameters.filters.join('&') + "&";
    }

    return newurl;
}

module.exports = {
    headers: () => auth.header(),
    get: (url, parameters, successCallback, errorCallback, failCallback) => {
        return axios.get(generateUrl(url, parameters))
            .then(response => {
                if (response.status == 200) {
                    if (successCallback) successCallback(response.data)
                } else {
                    if (errorCallback) errorCallback(response.data)
                }
                return response.data;
            }).catch(error => {
                let response = error.response;
                if (response) {
                    if (errorCallback) errorCallback(response.data)
                } else {
                    if (failCallback) failCallback(response)
                }
            })
    },
}


// WEBPACK FOOTER //
// ./src/api/georef/functions.js